import { faClose, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useRef } from 'react';

export type AgregarElementoProps = {
	title: string;
	children: React.ReactNode;
	titleButton: string;
	open?: boolean;
	onSwitchOpen: (value:boolean) => void;
}

const AgregarElementoModal: React.FC<AgregarElementoProps> = ({ title, children, titleButton, open, onSwitchOpen }) => {

	const ref = useRef<HTMLDialogElement>(null);

	const openModal = useCallback(() => {
		ref.current?.showModal();
	}, [ref]);

	const closeModal = useCallback(() => {
		ref.current?.close();
	}, [ref]);

	React.useEffect(()=> {
		console.log("open AgregarElementoModal", open);
		if(open) {
			ref.current?.showModal();
		} else {
			ref.current?.close();
		}
	}, [open]);

	return <>
			<button className='flex flex-row gap-2 items-center btn btn-sm' onClick={()=>onSwitchOpen(true)} >
				<FontAwesomeIcon className='' icon={faPlusCircle} />
				<h1 className='font-semibold lg:block hidden'>
					{titleButton}
				</h1>
			</button>
			<dialog ref={ref} className='modal-box text-center'>
				<h1 className="text-lg font-bold">{title}</h1>
				<button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={()=>onSwitchOpen(false)} >
					<FontAwesomeIcon icon={faClose}/>
				</button>
				{children}
			</dialog>
		</>
};

export default AgregarElementoModal;
